import React, { useEffect, } from "react";
import home from "./Home2.module.css";
import { Link, useHistory } from "react-router-dom";
import { getUserInfo, LogoutUser } from "../../Api/BarestServices";
import SearchHome from "../../Component/SearchHome/SearchHome";
import { useTransferReasons } from "../../Context/TransferReasonContext";

import Installments from "./Components/Installments";
import SliderContainer from "./Sliders/SliderContainer";
import DebitMemo from "./Components/DebitMemo";

const Home = () => {
  let ref = new URLSearchParams(window.location.search).get("ref");
  const { userInfoData } = useTransferReasons();

  useEffect(() => {
    getUser();
    if (ref) {
      localStorage.setItem("ref", ref);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const LogoutHandler = () => {
    let info = {
      logout: "",
    };
    LogoutUser(info, (succ) => {
      return;
    });
  };
  let history = useHistory();
  const getUser = async () => {
    getUserInfo((succ, res) => {
      if (succ) {
        if (res.status === 0 || res.status === -2) {
          console.warn("کاربر وارد نشده!");
        } else {
          if (res.status === 0) {
            localStorage.removeItem("JwtTokens");
          } else if (localStorage.getItem("JwtTokens")) {
            if (res.status === -2) {
              LogoutHandler();
              localStorage.removeItem("JwtTokens");
              localStorage.clear();
              history.push("/login");
            }
          } else {
          }
        }
      } else {
        console.error(res);
      }
    });
  };
  return (
    <div className={home.pageHolder}>
        <h2 className={home.pageTitle}>بَرِست در خدمت شما</h2>
        <SearchHome />
         {userInfoData?.facture && userInfoData?.facture!=="0" && <DebitMemo factourCount={userInfoData?.facture}/>}
        <div className={home.khadamat}>
          {/* <div className={home.firstColumnHolder}>
            <Link to="/voiceorder">
              <div className={`${home.singleKhadamat}`} style={{background:'#ff8c57'}}>
                <div className={home.picPart}>
                  <img src={"/Assets/Images/HomePage/VoiceOrder.png"} alt="ُسفارش هوشمند برست" />
                </div>
                <h3>سفارش هوشمند صوتی</h3>
              </div>
            </Link>
          </div> */}
          <div className={home.firstColumnHolder}>
            <Link to="/Supermarket">
              <div className={`${home.khadamatPart} ${home.supermarket}`}>
                <div className={home.picPart}>
                  <img
                    src={"/Assets/Images/HomePage/supermarket.png"}
                    alt="فروشگاه"
                  />
                </div>
                <h3>فروشگاه</h3>
              </div>
            </Link>
            <Link to="/Restaurants">
              <div className={`${home.khadamatPart} ${home.resturant}`}>
                <div className={home.picPart}>
                  <img src={"/Assets/Images/HomePage/rest.png"} alt="رستوران" />
                </div>
                <h3>رستوران و کافه</h3>
              </div>
            </Link>
          </div>
          <div className={home.firstColumnHolder}>
            <Link to="/deliveryrequest">
              {/* <Link to="/comingsoon"> */}
              <div className={`${home.khadamatPart} ${home.deliver}`}>
                <div className={home.picPart}>
                  <img src={"/Assets/Images/HomePage/peyk2.png"} alt=" " />
                </div>
                <h3>درخواست پیک</h3>
              </div>
            </Link>
            <Link to="/comingsoon">
            {/* <Link to="/taxireqlist"> */}
              <div className={`${home.khadamatPart} ${home.taxi}`}>
                <div className={home.picPart}>
                  <img src={"/Assets/Images/HomePage/1.png"} alt=" " />
                </div>
                <h3>تاکسی</h3>
              </div>
            </Link>
          </div>
          <div className={home.firstColumnHolder}>
            <Link to="/baresthelp">
              <div className={`${home.singleKhadamat}`} style={{background:'#ff8ad8'}}>
                <div className={home.picPart}>
                  <img src={"/Assets/Images/HomePage/Heart.png"} alt="کمک برست" />
                </div>
                <h3>کمک برست</h3>
              </div>
            </Link>
          </div>
        </div>
        <Link className={home.supportIcon} to={"/support"}>
          <img src="/Assets/Images/support/support_icon.png" alt="پشتیبانی" />
        </Link>
        {userInfoData?.installments && (
          <ul className={home.debtListHolder}>
            {userInfoData?.installments?.map((item) => {
              return (
                <li className={home.debtItemHolder} key={item?.id}>
                  <Installments item={item} />
                </li>
              );
            })}
          </ul>
        )}
        {userInfoData.phone&&<SliderContainer/>}
    </div>
  );
};

export default Home;
